var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { getFetchArgs, providesList } from "../../utils.js";
import { authoringApi } from "../api.js";
import { URL_SEGMENTS, TAGS } from "../common.js";
const resource = URL_SEGMENTS.EXPERIMENT_STEP;
const experimentStepApi = authoringApi.injectEndpoints({
  endpoints: (builder) => ({
    getExperimentStepById: builder.query({
      query: (payload) => getFetchArgs({ resource, payload }),
      providesTags: (result, error, { id }) => [{ type: TAGS.EXPERIMENT_STEP, id }]
    }),
    queryExperimentSteps: builder.query({
      query: (payload) => getFetchArgs({ resource, payload }),
      providesTags: (result) => providesList(result == null ? void 0 : result.value, TAGS.EXPERIMENT_STEP)
    }),
    createOrUpdateExperimentStep: builder.mutation({
      query: (payload) => getFetchArgs({ resource, payload, method: "PUT" }),
      invalidatesTags: (result, error, { entity }, meta) => {
        var _a;
        return [
          ...providesList([entity], TAGS.EXPERIMENT_STEP, ((_a = meta == null ? void 0 : meta.response) == null ? void 0 : _a.status) === 201),
          { type: TAGS.EXPERIMENT, id: entity.experimentId }
        ];
      },
      onQueryStarted: (_0, _1) => __async(void 0, [_0, _1], function* ({ id, workspaceId }, { queryFulfilled, dispatch, getState }) {
        try {
          const { data, meta } = yield queryFulfilled;
          dispatch(
            experimentStepApi.util.updateQueryData(
              "getExperimentStepById",
              { workspaceId, id: data.id },
              (draft) => {
                Object.assign(draft, data);
              }
            )
          );
        } catch (e) {
        }
      })
    }),
    deleteExperimentStep: builder.mutation({
      query: (payload) => getFetchArgs({ resource, payload, method: "DELETE" }),
      invalidatesTags: (result, error, { id }) => providesList([{ id }], TAGS.EXPERIMENT_STEP)
    })
  })
});
const {
  usePrefetch: usePrefetchExperimentSteps,
  useGetExperimentStepByIdQuery,
  useLazyGetExperimentStepByIdQuery,
  useQueryExperimentStepsQuery,
  useLazyQueryExperimentStepsQuery,
  useCreateOrUpdateExperimentStepMutation,
  useDeleteExperimentStepMutation
} = experimentStepApi;
export {
  experimentStepApi,
  useCreateOrUpdateExperimentStepMutation,
  useDeleteExperimentStepMutation,
  useGetExperimentStepByIdQuery,
  useLazyGetExperimentStepByIdQuery,
  useLazyQueryExperimentStepsQuery,
  usePrefetchExperimentSteps,
  useQueryExperimentStepsQuery
};
//# sourceMappingURL=experiment-steps.js.map
